import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import { CustomSwitch } from "components/common/Switch";
import { SubmitButton } from "components/common/buttons/SubmitButton";
import ErrorMessage from "components/common/ErrorMessage";
import { setError } from "slices/typeSlice";
import { updateType } from "slices/typeSlice";
import { addType } from "slices/typeSlice";
import { typesSelector } from "slices/typeSlice";
import { Controller, FormProvider, useForm } from "react-hook-form";
import PhoneInput from "components/common/PhoneInput";
import { AsyncPaginate } from "react-select-async-paginate";
import { selectCustomStyles } from "components/common/Select";
import TagInput from "components/TagInput";
import { fetchStates } from "slices/stateSlice";
import { stateSelector } from "slices/stateSlice";
import { Select } from "components/common/Select";
import { IconButton, Switch } from "@mui/material";
import { useNavigate } from "react-router-dom";
import FullPageLoader from "components/common/FullPageLoader";
import CustomTiers from "./CustomTiers";
import LanguageTiers from "./LanguageTiers";
import FilterSwitch from "./FilterSwitch";
import { usePermissions } from "layouts/Admin";
import DynamicFacilities from "./DynamicFacilities";
import { fetchCountries } from "slices/countrySlice";
import { fetchTimezone } from "slices/timezoneSlice";
import { USA } from "constants/common";
import RushFeeModal from 'components/common/RushFeeModal';
import { fetchLanguages, languageSelector } from 'slices/languageSlice';
const AccountForm = ({ item }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [clientTierId, setClientTierId] = useState([]);
  const { checkPermission } = usePermissions();
  const [lockStates, setLockStates] = useState({});
  const { state: states } = useSelector(stateSelector);
  const [allStates, setAllStates] = useState([]);

  const [filterStates, setfilterStates] = useState({
    label: "",
    value: "",
  });

  const [filterCountries, setfilterCountries] = useState({
    label: "",
    value: "",
  });

  console.log("ClientItems", item);
  const interpretationRates = {
    opi_normal_rate: [],
    vri_normal_rate: [],
    inperson_normal_rate: [],
    opi_normal_rate_time_unit: [],
    vri_normal_rate_time_unit: [],
    inperson_normal_time_unit: [],
    opi_normal_mins: [],
    vri_normal_mins: [],
    inperson_normal_mins: [],
    opi_after_rate: [],
    vri_after_rate: [],
    inperson_after_rate: [],
    opi_after_rate_time_unit: [],
    vri_after_rate_time_unit: [],
    inperson_after_time_unit: [],
    opi_after_mins: [],
    vri_after_mins: [],
    inperson_after_mins: [],
  };
  const handleClientData = (clientData) => {
    setValue("client_tier_id", clientData);
  };
  const methods = useForm({
    defaultValues: {
      interpretationRates,
      client_tier_id: [],
    },
  });
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    control,
    setValue,
    clearErrors,
    resetField,
    unregister,
  } = methods;
  const { loader, error } = useSelector(typesSelector);
  const { language: languagesList } = useSelector(languageSelector);
  const [status, setStatus] = useState(1);
  const [credentialsSend, setCredentialsSend] = useState(0);
  const [notification, setNotification] = useState(1);
  const [noOfVariants, setNoOfVariants] = useState([
    {
      field: "",
      required: 0,
    },
  ]);
  const [filterTimezones, setFilterTimezones] = useState({
    label: "",
    value: "",
  });
  const resetAllFields = () => {
    setValue("name", "");
    setValue("email", "");
    setValue("password", "");
    setValue("phone", "");
    setValue("us_based", false);
    setValue("non_us_based", false);
    setValue("english_to_target", false);
    setValue("spanish_to_target", false);
    setValue("medical_certified", false);
    setValue("court_certified", false);
    setValue("dynamic_fields", []);
    setStatus(1);
    clearErrors("english_to_target");
    setValue("facility_names", []);
    setValue("department_names", []);
    setValue("subaccount_names", []);
    setLockStates(false);
  };

  const [languageRushes, setLanguageRushes] = useState([]);
  const [languageRow, setLanguageRow] = useState({ languageId: '', languageLabel: '', rush_fee: '' });
  const [languageEditId, setLanguageEditId] = useState(null);

  const filteredLanguagesLoadOptions = async (inputValue, loadedOptions, { page }) => {
    const result = await dispatch(fetchLanguages(page, { pageLength: 20, sortBy: "id", sortDirection: "asc", search: inputValue }, true, true));
    return {
      options: (result?.data || []).map(lang => ({ value: lang.id, label: lang.name })),
      hasMore: page !== result?.last_page,
      additional: { page: page + 1 },
    };
  };

  const handleAddLanguageRush = () => {
    if (!languageRow.languageId || languageRow.rush_fee === '') return;
    if (languageEditId) {
      setLanguageRushes(prev => prev.map(l => l.id === languageEditId ? { ...l, ...languageRow } : l));
      setLanguageEditId(null);
    } else {
      setLanguageRushes(prev => [...prev, { id: '', ...languageRow }]);
    }
    setLanguageRow({ languageId: '', languageLabel: '', rush_fee: '' });
  };

  const handleEditLanguageRush = (id) => {
    const found = languageRushes.find(l => l.id === id);
    if (found) {
      // open modal with this item
      setModalInitial({ id: found.id, languageId: found.languageId, languageLabel: found.languageLabel, rush_fee: found.rush_fee });
      setIsRushModalOpen(true);
    }
  };

  const handleDeleteLanguageRush = (id) => setLanguageRushes(prev => prev.filter(l => l.id !== id));

  // Rush Fee modal state
  const [isRushModalOpen, setIsRushModalOpen] = useState(false);
  const [modalInitial, setModalInitial] = useState({});

  const handleRushModalUpdate = (updated) => {
    setLanguageRushes(prev => prev.map(l => l.id === modalInitial.id ? { ...l, languageId: updated.languageId, languageLabel: updated.languageLabel, rush_fee: updated.rush_fee } : l));
  };

  useEffect(() => {
    setValue("name", item?.name || "");
    setValue("email", item?.email || "");
    setValue("password", "");
    setValue("phone", item?.phone || "");
    setValue(
      "facility_names",
      item?.facilities?.map((i) => i.abbreviation) || []
    );
    setValue("department_names", item?.departments?.map((i) => i.name) || []);
    setValue("subaccount_names", item?.sub_accounts?.map((i) => i.name) || []);

    setValue("us_based", item?.filters?.us_based == 1 ? true : false || false);
    setValue(
      "non_us_based",
      item?.filters?.non_us_based == 1 ? true : false || false
    );
    setValue(
      "english_to_target",
      item?.filters?.english_to_target == 1 ? true : false || false
    );
    setValue(
      "spanish_to_target",
      item?.filters?.spanish_to_target == 1 ? true : false || false
    );
    setValue(
      "medical_certified",
      item?.filters?.medical_certified == 1 ? true : false || false
    );
    setValue(
      "court_certified",
      item?.filters?.court_certified == 1 ? true : false || false
    );

    setValue(
      "us_based_locked",
      item?.filters?.us_based_locked == 1 ? true : false || false
    );
    setValue(
      "non_us_based_locked",
      item?.filters?.non_us_based_locked == 1 ? true : false || false
    );
    setValue(
      "english_to_target_locked",
      item?.filters?.english_to_target_locked == 1 ? true : false || false
    );
    setValue(
      "spanish_to_target_locked",
      item?.filters?.spanish_to_target_locked == 1 ? true : false || false
    );
    setValue(
      "medical_certified_locked",
      item?.filters?.medical_certified_locked == 1 ? true : false || false
    );
    setValue(
      "court_certified_locked",
      item?.filters?.court_certified_locked == 1 ? true : false || false
    );

    setValue("billing_email", item?.billing_email || "");
    setValue("billing_person", item?.billing_person || "");
    setValue("billing_zipcode", item?.billing_zipcode || "");
    setValue("billing_state_id", item?.billing_state?.id || "");
    setValue("billing_city_name", item?.billing_city_name || "");
    setValue("billing_phone", item?.billing_phone || "");
    setValue("timezone_id", item?.timezone_id || "");

    setValue("invoicing_period", item?.invoicing_period || "");

    const temp_array = [];
    setValue(
      "dynamic_fields",
      item?.dynamic_fields?.map((p) => {
        temp_array.push({
          field: p?.name,
          id: p?.id,
          required: p?.required,
        });
        return p?.name;
      })
    );

    temp_array?.length > 0
      ? setNoOfVariants(temp_array)
      : setNoOfVariants([{ field: "", id: 1, required: 0 }]);

    setValue(
      "spanish_translation_rate",
      item?.translationRates?.spanish_translation_rate || ""
    );
    // Initialize booking rate when editing an existing item (try several possible keys)
    setValue(
      "booking_rate",
      item?.booking_rate ?? ""
    );
    console.log(item, 'itemmmm')
    setValue(
      "other_translation_rate",
      item?.translationRates?.other_translation_rate || ""
    );
    setValue(
      "spanish_formatting_rate",
      item?.translationRates?.spanish_formatting_rate || ""
    );
    setValue(
      "other_formatting_rate",
      item?.translationRates?.other_formatting_rate || ""
    );
    // Initialize language-specific rush fees from the item when editing
    const existingRushes = item?.rush_fees || item?.rushFees || [];
    if (existingRushes && existingRushes.length > 0) {
      const mapped = existingRushes.map((r) => {

        return {
          id: r.id ?? '',
          languageId: r.language_id || r.languageId || "",
          languageLabel: r?.language_name || `Language ${r.language_id || r.languageId}`,
          rush_fee: r.rush_fee ?? r.rushFee ?? "",
        };
      });
      setLanguageRushes(mapped);
    } else {
      setLanguageRushes([]);
    }
    setStatus(typeof item?.status == "number" ? item?.status : 1);
    setCredentialsSend(
      typeof item?.user?.credentials_send == "number"
        ? item?.user?.credentials_send
        : 0
    );
    setNotification(
      typeof item?.user?.notifications == "number"
        ? item?.user?.notifications
        : 1
    );

    dispatch(setError({}));

    return () => {
      resetAllFields();
    };
  }, [item, languagesList]);

  //#region Dynamic fields
  const handleAdd = React.useCallback(() => {
    const newVariants = [...noOfVariants];
    newVariants.push({
      field: "",
      id: newVariants.length + 1,
      required: false,
    });
    setNoOfVariants(newVariants);
  }, [noOfVariants]);

  const handleRemove = React.useCallback(
    (index) => {
      const newVariants = [...noOfVariants];
      newVariants.splice(index, 1);
      setNoOfVariants(newVariants);
    },
    [noOfVariants]
  );

  const toggleRequired = (index) => {
    const newVariants = [...noOfVariants];
    newVariants[index].required = !newVariants[index].required;
    setNoOfVariants(newVariants);
  };

  useEffect(() => {
    setValue(
      "dynamic_fields",
      noOfVariants?.map((variant) => variant.field)
    );
    setValue(
      "dynamic_fields_required",
      noOfVariants?.map((variant) => (variant.required ? 1 : 0))
    );
  }, [noOfVariants, setValue]);

  const renderDynamicField = React.useCallback(
    (variant, index) => {
      return (
        <>
          <div
            className="row-primary mb-0 align-items-center mt-2"
            key={variant?.id}
            id={variant?.id}
          >
            <Controller
              name={`dynamic_fields[${index}]`}
              control={control}
              render={({ field }) => (
                <input
                  className="input-in type_inp"
                  type="text"
                  placeholder=""
                  value={variant?.field}
                  onChange={(e) => {
                    const newVariants = [...noOfVariants];
                    newVariants[index].field = e.target.value;
                    setNoOfVariants(newVariants);
                  }}
                />
              )}
            />

            {noOfVariants?.length > 1 && (
              <IconButton color="error" onClick={() => handleRemove(index)}>
                <i className="fa-solid fa-trash-can trash_icon"></i>
              </IconButton>
            )}

            <div className="col-1">
              <h3 className="fst-italic mt-0">Required</h3>
              <Switch
                name={`dynamic_fields_required[${index}]`}
                checked={variant.required}
                onChange={() => toggleRequired(index)}
                color="primary"
              />
            </div>
          </div>
        </>
      );
    },
    [noOfVariants, errors]
  );
  //#endregion

  // #region States dropdown

  useEffect(() => {
    dispatch(fetchStates(1, { id: item?.billing_state?.id }));
    if (item?.billing_state?.name && item?.billing_state?.id) {
      setfilterStates({
        label: item?.billing_state?.name || "",
        value: item?.billing_state?.id || "",
      });
    } else {
      setfilterStates(null);
    }
  }, [item?.billing_state]);

  const filteredStatesLoadOptions = async (
    inputValue,
    loadedOptions,
    { page }
  ) => {
    const result = await dispatch(
      fetchStates(
        page,
        {
          pageLength: 20,
          sortBy: "id",
          sortDirection: "asc",
          search: inputValue,
        },
        true,
        true
      )
    );
    setAllStates(result?.data);
    return {
      options: result.data.map((val) => ({
        value: val.id,
        label: val.name,
      })),

      hasMore: page !== result?.last_page,
      additional: {
        page: page + 1,
      },
    };
  };
  //#endregion

  // #region City dropdown

  const filteredStates = React.useMemo(() => {
    return states?.map((item) => {
      const object = {
        label: item?.name,
        value: item?.id,
      };
      return object;
    });
  }, [states, item?.billing_state?.name]);

  //#endregion

  // #region Timezone dropdown

  useEffect(() => {
    const fetchAndSetUSA = async () => {
      const result = await dispatch(
        fetchCountries(1, { search: USA }, true, true)
      );
      const countries = result?.data || [];
      const usa = countries.find((c) => c.name === USA);
      if (usa) {
        setfilterCountries({
          label: usa.name,
          value: usa.id,
        });
      }
    };

    fetchAndSetUSA();
  }, []);

  useEffect(() => {
    setFilterTimezones({
      value: item?.timezone?.id,
      label: item?.timezone?.display_name,
    });
  }, [item?.timezone]);

  // Load options function (API call to timezone endpoint)
  const filteredTimezonesLoadOptions = async (
    inputValue,
    loadedOptions,
    { page }
  ) => {
    const country_id = filterCountries.value;

    const result = await dispatch(
      fetchTimezone(
        page,
        {
          pageLength: 10,
          sortBy: "id",
          sortDirection: "asc",
          search: inputValue,
          country_id: country_id,
        },
        true,
        true
      )
    );

    return {
      options: result.data.map((val) => ({
        value: val.id,
        label: val.display_name,
      })),
      hasMore: page !== result?.last_page,
      additional: {
        page: page + 1,
      },
    };
  };

  //#endregion

  const submitCallback = (status, message) => {
    if (status) {
      toast.success(message, {
        className: "successToast",
      });
      resetAllFields();
      navigate(-1);
    } else {
      console.log("onSubmit", error);
      toast.error(message, {
        className: "errorToast",
      });
    }
  };

  // const onSubmit = (data) => {
  //   dispatch(setError({}));
  //   const newData = {
  //     ...data,
  //     ...data.interpretationRates,
  //     status,
  //     credentialsSend,
  //     notification,
  //   };
  //   delete data.interpretationRates;

  //   if (item?.id) {
  //     if (newData.password === "") {
  //       delete newData.password;
  //     }
  //     dispatch(updateType(newData, item?.id, submitCallback));
  //   } else {
  //     dispatch(addType(newData, submitCallback));
  //   }
  // };

  const onSubmit = (data) => {
    dispatch(setError({}));

    const newData = {
      ...data,
      ...data.interpretationRates,
      status,
      credentialsSend,
      notification,
      booking_rate: Number(data.booking_rate),
      // include per-language rush fees
      language_rushes: languageRushes.map(lr => ({ language_id: lr.languageId, rush_fee: Number(lr.rush_fee) })),
      spanish_translation_rate: Number(data.spanish_translation_rate),
      other_translation_rate: Number(data.other_translation_rate),
      spanish_formatting_rate: Number(data.spanish_formatting_rate),
      other_formatting_rate: Number(data.other_formatting_rate),
    };

    console.log("Submitting newData:", newData);

    delete data.interpretationRates;

    if (languageRushes.length > 0) {
      const formData = new FormData();
      Object.keys(newData).forEach((key) => {
        if (key === 'language_rushes') return;
        const val = newData[key];
        if (val === undefined || val === null) {
          formData.append(key, '');
        } else if (typeof val === 'boolean') {
          formData.append(key, val ? '1' : '0');
        } else if (Array.isArray(val)) {
          val.forEach((it) => {
            if (it === undefined || it === null) {
              formData.append(`${key}[]`, '');
            } else if (typeof it === 'object') {
              try {
                formData.append(`${key}[]`, JSON.stringify(it));
              } catch (e) {
                formData.append(`${key}[]`, String(it));
              }
            } else {
              formData.append(`${key}[]`, String(it));
            }
          });
        } else if (typeof val === 'object') {
          // non-array objects: stringify
          try {
            formData.append(key, JSON.stringify(val));
          } catch (e) {
            formData.append(key, String(val));
          }
        } else {
          formData.append(key, String(val));
        }
      });

      languageRushes.forEach((lr, idx) => {
        // language_rushes payload
        formData.append(`language_rushes[${idx}][language_id]`, String(lr.languageId || ''));
        formData.append(`language_rushes[${idx}][rush_fee]`, String(lr.rush_fee || ''));
        if (lr.id && typeof lr.id === 'number') {
          formData.append(`language_rushes[${idx}][id]`, String(lr.id));
        }

        // duplicate under legacy/alternative key `rush_fees` (some endpoints expect this)
        // formData.append(`rush_fees[${idx}][language_id]`, String(lr.languageId || ''));
        // formData.append(`rush_fees[${idx}][rush_fee]`, String(lr.rush_fee || ''));
        // if (lr.id && typeof lr.id === 'number') {
        //   formData.append(`rush_fees[${idx}][id]`, String(lr.id));
        // }
      });

      if (item?.id) {
        if (newData.password === "") {
          // remove password field from formData
          formData.delete('password');
        }
        dispatch(updateType(formData, item?.id, submitCallback));
      } else {
        dispatch(addType(formData, submitCallback));
      }
    } else {
      if (item?.id) {
        if (newData.password === "") {
          delete newData.password;
        }
        dispatch(updateType(newData, item?.id, submitCallback));
      } else {
        dispatch(addType(newData, submitCallback));
      }
    }
  };

  return (
    <>
      <FormProvider {...methods}>
        <form className="card_table p-4" onSubmit={handleSubmit(onSubmit)}>
          {/* Main credientials area  */}
          <div className="foam_page_row accounts_form">
            <div className="row-primary">
              <h2>Organization Name *</h2>
              <div className="w-100">
                <Controller
                  name="name"
                  rules={{
                    required: "Organization name is required",
                  }}
                  control={control}
                  render={({ field }) => (
                    <input
                      className="input-in type_inp"
                      type="text"
                      name="name"
                      placeholder="Name"
                      {...field}
                    />
                  )}
                />
                {error?.errors?.name?.map((error) => (
                  <div style={{ marginTop: 10 }}>
                    <ErrorMessage text={error} />
                  </div>
                ))}
                {errors?.name?.message && (
                  <div style={{ marginBottom: 10 }}>
                    <ErrorMessage text={errors?.name?.message} />
                  </div>
                )}
              </div>
            </div>

            <div className="row-primary">
              <h2>Email *</h2>
              <div className="w-100">
                <Controller
                  name="email"
                  rules={{
                    required: "Email is required",
                  }}
                  control={control}
                  render={({ field }) => (
                    <input
                      className={`input-in type_inp ${error?.errors?.email ? "border-red" : ""
                        } `}
                      type="email"
                      autoComplete="off"
                      name="email"
                      pattern={
                        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
                      }
                      placeholder="Email Address"
                      {...field}
                    />
                  )}
                />
                {error?.errors?.email?.map((error) => (
                  <div style={{ marginTop: 10 }}>
                    <ErrorMessage text={error} />
                  </div>
                ))}
                {errors?.email?.message && (
                  <div style={{ marginBottom: 10 }}>
                    <ErrorMessage text={errors?.email?.message} />
                  </div>
                )}
              </div>
            </div>

            <div className="row-primary">
              <h2>Password {!item && "*"}</h2>
              <div className="w-100">
                <Controller
                  name="password"
                  rules={
                    !item && {
                      required: "Password is required",
                    }
                  }
                  control={control}
                  render={({ field }) => (
                    <input
                      className={`input-in type_inp `}
                      autoComplete="off"
                      type="password"
                      name="password"
                      placeholder="Password"
                      {...field}
                      disabled={watch("type") == "interpreter" ? true : false}
                    />
                  )}
                />
                {error?.errors?.password?.map((error) => (
                  <div style={{ marginTop: 10 }}>
                    <ErrorMessage text={error} />
                  </div>
                ))}
                {errors?.password?.message && (
                  <div style={{ marginBottom: 10 }}>
                    <ErrorMessage text={errors?.password?.message} />
                  </div>
                )}
              </div>
            </div>

            <div className="row-primary">
              <h2>Phone</h2>
              <div className="w-100">
                <Controller
                  name="phone"
                  control={control}
                  render={({ field }) => (
                    <PhoneInput
                      className={`input-in type_inp ${error?.errors?.phone ? "border-red" : ""
                        } `}
                      type="tel"
                      name="contact"
                      placeholder="Phone number"
                      {...field}
                    />
                  )}
                />
                {error?.errors?.phone?.map((error) => (
                  <div style={{ marginTop: 10 }}>
                    <ErrorMessage text={error} />
                  </div>
                ))}
              </div>
            </div>

            <div className="row-primary">
              <h2>Timezone*</h2>
              <Controller
                name="timezone_id"
                control={control}
                rules={{ required: "Please select a Timezone" }}
                render={({ field }) => (
                  <div style={{ width: "100%" }}>
                    <AsyncPaginate
                      styles={selectCustomStyles}
                      value={filterTimezones}
                      loadOptions={filteredTimezonesLoadOptions}
                      isClearable
                      placeholder="Select Timezone"
                      onChange={(selected) => {
                        setFilterTimezones(selected);
                        setValue("timezone_id", selected?.value || "");
                        field.onChange(selected?.value || "");
                      }}
                      additional={{ page: 1 }}
                    />
                    {errors?.timezone_id?.message && (
                      <div style={{ marginBottom: 10 }}>
                        <ErrorMessage text={errors?.timezone_id?.message} />
                      </div>
                    )}
                  </div>
                )}
              />
            </div>
            <div className="row-primary">
              <h2>Booking Rate *</h2>
              <div style={{ width: "100%" }}>
                <Controller
                  name="booking_rate"
                  control={control}
                  rules={{ required: "Booking rate is required" }}
                  render={({ field }) => (
                    <input
                      className="input-in type_inp"
                      type="number"
                      min={0}
                      step={0.01}
                      name="booking_rate"
                      placeholder="Booking rate"
                      style={{
                        width: "100%",
                        minHeight: 40,
                        marginBottom: 0,
                      }}
                      {...field}
                    />
                  )}
                />
                {errors?.booking_rate?.message && (
                  <div style={{ marginBottom: 10 }}>
                    <ErrorMessage text={errors?.booking_rate?.message} />
                  </div>
                )}
              </div>
            </div>
            <div className="row-primary Credentials">
              <h2 className="m-0">Credentials will be sent over email</h2>
              <label className="custom-checkbox checkbox">
                <input
                  type="checkbox"
                  name="credentials_send"
                  checked={credentialsSend === 1 ? true : false}
                  onChange={(e) => setCredentialsSend(e.target.checked ? 1 : 0)}
                />
                <span className="checkmark"></span>
              </label>
            </div>

            <div className="row-primary Credentials">
              <h2 className="mt-0">
                Notifications{" "}
                <span className="opacity-50">
                  (all type of notification regarding appointments)
                </span>
              </h2>
              <CustomSwitch
                labelText="notifications"
                checked={notification == 1 ? true : false}
                handleChange={(checked) => setNotification(checked ? 1 : 0)}
              />
            </div>
          </div>

          {/* facilities tag input */}
          <DynamicFacilities item={item} />

          {/* department tag input */}
          <div className="row-primary">
            <h2>Departments</h2>

            <Controller
              name="department_names"
              control={control}
              render={({ field }) => (
                <div style={{ width: "100%" }}>
                  <TagInput
                    value={field.value}
                    onChange={(obj) => {
                      field.onChange(obj);
                    }}
                  />
                </div>
              )}
            />
          </div>
          {/* subaccount tag input */}
          {/* <div className="row-primary">
            <h2>Sub account</h2>
            <Controller
              name="subaccount_names"
              control={control}
              render={({ field }) => (
                <div style={{ width: "100%" }}>
                  <TagInput
                    value={field.value}
                    onChange={(obj) => {
                      field.onChange(obj);
                    }}
                  />
                </div>
              )}
            />
          </div> */}

          <FilterSwitch
            setLockStates={setLockStates}
            item={item}
            setValue={setValue}
            lockStates={lockStates}
            control={control}
          />

          <hr />
          {/* Billing info area  */}
          <div className="w-100 biling_info">
            <div className="row-primary row-r justify-content-between flex-row">
              <h2 className="fst-italic">Biling information </h2>
            </div>
            <div className="foam_page_row">
              <div className="row-primary">
                <h2>Email *</h2>
                <div className="w-100">
                  <Controller
                    name="billing_email"
                    control={control}
                    rules={{
                      required: "Billing email is required",
                    }}
                    render={({ field }) => (
                      <input
                        className={`input-in type_inp ${error?.errors?.billing_email ? "border-red" : ""
                          } `}
                        type="email"
                        autoComplete="off"
                        name="billing_email"
                        pattern={
                          /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
                        }
                        placeholder="Email Address"
                        {...field}
                      />
                    )}
                  />
                  {errors?.billing_email?.message && (
                    <div style={{ marginBottom: 10 }}>
                      <ErrorMessage text={errors?.billing_email?.message} />
                    </div>
                  )}
                </div>
              </div>

              <div className="row-primary">
                <h2>Contact Person Name</h2>
                <div className="w-100">
                  <Controller
                    name="billing_person"
                    control={control}
                    render={({ field }) => (
                      <input
                        className="input-in type_inp"
                        type="text"
                        name="billing_person"
                        placeholder="Name"
                        {...field}
                      />
                    )}
                  />
                </div>
              </div>

              <div className="row-primary">
                <h2>Select State *</h2>

                <Controller
                  name="billing_state_id"
                  control={control}
                  rules={{
                    required: "Please select a state",
                  }}
                  render={({ field }) => (
                    <div style={{ width: "100%" }}>
                      <AsyncPaginate
                        menuPlacement="auto"
                        styles={{
                          ...selectCustomStyles,
                        }}
                        value={filterStates}
                        loadOptions={filteredStatesLoadOptions}
                        isClearable
                        escapeClearsValue
                        onChange={(obj) => {
                          setfilterStates(obj);

                          field.onChange(obj?.value);
                        }}
                        additional={{
                          page: 1,
                        }}
                      />
                      {errors?.billing_state_id?.message && (
                        <div style={{ marginBottom: 10 }}>
                          <ErrorMessage
                            text={errors?.billing_state_id?.message}
                          />
                        </div>
                      )}
                    </div>
                  )}
                />
              </div>

              <div className="row-primary">
                <h2>City Name *</h2>
                <Controller
                  name="billing_city_name"
                  control={control}
                  render={({ field }) => (
                    <div className="w-100">
                      <input
                        className="input-in type_inp"
                        type="text"
                        name="billing_city_name"
                        placeholder="Enter City Name"
                        {...field}
                      />
                      {errors?.city_name?.message && (
                        <div style={{ marginBottom: 10 }}>
                          <ErrorMessage text={errors?.city_name?.message} />
                        </div>
                      )}
                    </div>
                  )}
                />
              </div>

              <div className="row-primary">
                <h2>Zip Code *</h2>
                <div className="w-100">
                  <Controller
                    name="billing_zipcode"
                    rules={{
                      required: "Zip Code is required",
                    }}
                    control={control}
                    render={({ field }) => (
                      <input
                        className="input-in type_inp"
                        type="text"
                        name="billing_zipcode"
                        placeholder="Zip Code"
                        {...field}
                      />
                    )}
                  />
                  {errors?.billing_zipcode?.message && (
                    <div style={{ marginBottom: 10 }}>
                      <ErrorMessage text={errors?.billing_zipcode?.message} />
                    </div>
                  )}

                  {error?.errors?.billing_zipcode?.map((error) => (
                    <div style={{ marginTop: 10 }}>
                      <ErrorMessage text={error} />
                    </div>
                  ))}
                </div>
              </div>

              <div className="row-primary">
                <h2>Phone</h2>
                <div className="w-100">
                  <Controller
                    name="billing_phone"
                    control={control}
                    render={({ field }) => (
                      <PhoneInput
                        className={`input-in type_inp ${error?.errors?.billing_phone ? "border-red" : ""
                          } `}
                        type="tel"
                        name="contact"
                        placeholder="Phone number"
                        {...field}
                      />
                    )}
                  />
                  {error?.errors?.billing_phone?.map((error) => (
                    <div style={{ marginTop: 10 }}>
                      <ErrorMessage text={error} />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <hr />
          {/* Dynamic fields  */}
          {/* <div className="w-100 dynamic_fields">
            <hr />
            <div className="row-primary row-r justify-content-between flex-row">
              <h2>Dynamic Fields </h2>
              <SubmitButton
                btnText="Add"
                buttonType="button"
                handleSubmit={handleAdd}
              />
            </div>
            {noOfVariants?.map((variant, index) =>
              renderDynamicField(variant, index)
            )}
            <hr />
          </div> */}

          <LanguageTiers
            sendClientData={handleClientData}
            control={control}
            error={error}
            errors={errors}
            item={item}
            dispatch={dispatch}
            setValue={setValue}
            watch={watch}
          />

          <CustomTiers
            control={control}
            error={error}
            errors={errors}
            item={item}
            dispatch={dispatch}
            setValue={setValue}
            watch={watch}
            Controller={Controller}
            unregister={unregister}
          />

          <hr />
          {/* Translation Rates  */}
          <h2 className="text-center my-3 fw-bold fst-italic">
            Translation Rates
          </h2>
          <div className="row-primary" style={{ display: "flex", flexDirection: "column", gap: 12, marginTop: 20, marginBottom: 50, }}>
            <div style={{ display: "flex", gap: 24, alignItems: "center" }}>
              <div className="tanslation_rates">
                <div className="row-primary">
                  <h2 style={{ color: "#6c7a89" }}>
                    Spanish translation rate
                  </h2>
                </div>
                <div className="input_wrapper">
                  <Controller
                    name="spanish_translation_rate"
                    control={control}
                    render={({ field }) => (
                      <input
                        className="input-in type_inp"
                        type="number"
                        min={0}
                        step={0.01}
                        name="normal_start_time"
                        required
                        placeholder="Spanish translation rate"
                        style={{
                          width: "100%",
                          minHeight: 40,
                          marginBottom: 0,
                        }}
                        {...field}
                      />
                    )}
                  />
                  {errors?.spanish_translation_rate?.message && (
                    <div style={{ marginBottom: 10 }}>
                      <ErrorMessage
                        text={errors?.spanish_translation_rate?.message}
                      />
                    </div>
                  )}
                </div>
              </div>
              <div className="tanslation_rates">
                <div className="row-primary">
                  <h2 style={{ color: "#6c7a89" }}>Other translation rate</h2>
                </div>
                <div className="input_wrapper">
                  <Controller
                    name="other_translation_rate"
                    control={control}
                    render={({ field }) => (
                      <input
                        className="input-in type_inp"
                        type="number"
                        min={0}
                        step={0.01}
                        name="normal_end_time"
                        required
                        placeholder="Other translation rate"
                        style={{
                          width: "100%",
                          minHeight: 40,
                          marginBottom: 0,
                        }}
                        {...field}
                      />
                    )}
                  />
                  {errors?.other_translation_rate?.message && (
                    <div style={{ marginBottom: 10 }}>
                      <ErrorMessage
                        text={errors?.other_translation_rate?.message}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                gap: 24,
                alignItems: "center",
                marginTop: 24,
              }}
            >
              <div className="tanslation_rates">
              <div className="row-primary">
                <h2 style={{ color: "#6c7a89" }}>
                  Spanish formatting rate
                </h2>
              </div>
              <div className="input_wrapper">
                <Controller
                  name="spanish_formatting_rate"
                  control={control}
                  render={({ field }) => (
                    <input
                      className="input-in type_inp"
                      type="number"
                      min={0}
                      step={0.01}
                      name="after_start_time"
                      required
                      placeholder="Spanish formatting rate"
                      style={{
                        width: "100%",
                        minHeight: 40,
                        marginBottom: 0,
                      }}
                      {...field}
                    />
                  )}
                />
                {errors?.spanish_formatting_rate?.message && (
                  <div style={{ marginBottom: 10 }}>
                    <ErrorMessage
                      text={errors?.spanish_formatting_rate?.message}
                    />
                  </div>
                )}
              </div>
              </div>
              <div className="tanslation_rates">
              <div className="row-primary">
                <h2 style={{ color: "#6c7a89" }}>Other formatting rate</h2>
              </div>
              <div className="input_wrapper">
                <Controller
                  name="other_formatting_rate"
                  control={control}
                  render={({ field }) => (
                    <input
                      className="input-in type_inp"
                      type="number"
                      min={0}
                      step={0.01}
                      name="after_end_time"
                      required
                      placeholder="Other formatting rate"
                      style={{
                        width: "100%",
                        minHeight: 40,
                        marginBottom: 0,
                      }}
                      {...field}
                    />
                  )}
                />
                {errors?.other_formatting_rate?.message && (
                  <div style={{ marginBottom: 10 }}>
                    <ErrorMessage
                      text={errors?.other_formatting_rate?.message}
                    />
                  </div>
                )}
              </div>
              </div>
            </div>
          </div>

          <hr />
          {/* Translation Rates  */}
          <h2 className="text-center my-3 fw-bold fst-italic">
            Rush Fee
          </h2>

          {/* Language-specific Rush Fee CRUD (table) */}
          <div className="custom-table-wrapper card_table mt-3 rush_fee_table_wrapper">
            <table className="custom-table table rush_fee_table">
              <thead>
                <tr>
                  <th className="col-auto">#</th>
                  <th className="col-6">Language</th>
                  <th className="col-4">Rush Fee</th>
                  <th className="col text-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                {languageRushes.map((lr, idx) => (
                  <tr key={lr.id}>
                    <td className="col-auto">{idx + 1}</td>
                    <td style={{ overflow: 'auto', maxWidth: '300px' }}>{lr.languageLabel}</td>
                    <td>${(Number(lr.rush_fee) || 0).toFixed(2)}</td>
                    <td className="d-flex justify-content-end">
                      <button type="button" className="table_edit" onClick={() => handleEditLanguageRush(lr.id)}>Edit</button>
                      <button type="button" className="table_delete" style={{ marginLeft: "10px" }} onClick={() => handleDeleteLanguageRush(lr.id)}>Delete</button>
                    </td>
                  </tr>
                ))}

                <tr>
                  <td>—</td>
                  <td>
                    <AsyncPaginate
                      menuPlacement="auto"
                      styles={{ ...selectCustomStyles }}
                      value={languageRow.languageId ? { value: languageRow.languageId, label: languageRow.languageLabel } : null}
                      loadOptions={filteredLanguagesLoadOptions}
                      isClearable
                      escapeClearsValue
                      onChange={(selected) => {
                        const sel = Array.isArray(selected) ? selected[0] : selected;
                        setLanguageRow(prev => ({ ...prev, languageId: sel?.value || '', languageLabel: sel?.label || '' }));
                      }}
                      additional={{ page: 1 }}
                    />
                  </td>
                  <td>
                    <div className="row-primary m-0">
                      <input className="input-in type_inp" type="number" placeholder="Rush Fee" value={languageRow.rush_fee} onChange={(e) => setLanguageRow(prev => ({ ...prev, rush_fee: e.target.value }))} />
                    </div>
                  </td>
                  <td className="d-flex justify-content-end">
                    {languageEditId ? (
                      <button className="main_button" type="button" onClick={handleAddLanguageRush}>Update</button>
                    ) : (
                      <button className="main_button" type="button" onClick={handleAddLanguageRush}>Add</button>
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>


          <div className="Form-footer footer_fullpage">
            <div className="row-primary m-0 align-items-center template_switch">
              {checkPermission("Status Client Account") && (
                <>
                  <h2 className="mt-0">Status</h2>
                  <CustomSwitch
                    labelText="active"
                    checked={status == 1 ? true : false}
                    handleChange={(checked) => setStatus(checked ? 1 : 0)}
                  />
                </>
              )}
            </div>

            <SubmitButton
              loader={loader}
              btnText={item?.id ? "Update" : "Create"}
            />
          </div>
        </form>
      </FormProvider>

      {loader && <FullPageLoader />}
      <RushFeeModal
        isOpen={isRushModalOpen}
        onClose={() => setIsRushModalOpen(false)}
        onUpdate={handleRushModalUpdate}
        initial={modalInitial}
        loadLanguages={filteredLanguagesLoadOptions}
      />
    </>
  );
};

export default AccountForm;
